// ----------------------------------------------------------------------------
// Section: Video/Image & Text Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Script
import 'snippets/background-media/background-media';

// Styles
import './_video-image-text-block.scss';

// const VIDEO_IMAGE_SELECTOR = '.video-image-text__media';
// const VIDEO_BLOCK          = '.video-block';
// const PLAY_INIT_CLASS      = 'video-block--play-init';
// const IS_POSTERED_CLASS    = 'video-block--is-postered';

// document.querySelectorAll(VIDEO_IMAGE_SELECTOR)?.forEach((element) => {
//     const videoBlock = element.querySelector(VIDEO_BLOCK);
//     const video = element.querySelector('video');

//     if (video) {
//         video.addEventListener('pause', () => {
//             console.log("on pause");
//             if (videoBlock !== null && videoBlock.classList.contains(PLAY_INIT_CLASS) && videoBlock.classList.contains(IS_POSTERED_CLASS)) {
//                 console.log("triggred");
//                 videoBlock.classList.remove(IS_POSTERED_CLASS);
//             }
//         });
//     }
// });